/**
 * @fileoverview Agent definition for world-place-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world place's details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.places.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-place-details-ideation-v3',
  kind: 'primitive',
  name: 'World Place Details Ideation',
  description: 'Generates creative directions for developing a world place before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    taxonomyPath: 'world-building.places.details',
    usedBy: [
      'use-world-place-details-ideation-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'world-place-details-generator-v3',
    ],
  },
};
